import React, { Component } from "react";
import {
  Wrapper,
  CardBody,
  Row,
  ProfilePic,
  Title,
  Copy
} from "app/NativeComponents/common";

import moment from "moment";

const User = ({ user }) => {
  return (
    <Wrapper>
      <CardBody>
        <Row>
          <ProfilePic email={user.email} image={user.image} size={40} />
          <Wrapper
            style={{
              alignItems: "flex-start",
              justifyContent: "center"
            }}
          >
            <Title>{user.firstname + " " + user.lastname}</Title>
            <Copy>{user.email}</Copy>
            <Copy>
              Used promo code {user.promo} on{" "}
              {moment(user.date_created).format("MMMM Do, YYYY")}
            </Copy>
          </Wrapper>
        </Row>
      </CardBody>
    </Wrapper>
  );
};

export default User;
